import { FC, JSXElementConstructor, PromiseLikeOfReactNode, ReactElement, ReactNode } from 'react';
import dynamic from 'next/dynamic';
import { useFormat } from 'helpers/hooks/useFormat';
import { ArchiveBoxIcon, ArrowRightCircleIcon, CheckCircleIcon, SwatchIcon } from '@heroicons/react/24/outline';
import Button from 'components/commercetools-ui/atoms/button';

import Dropdown, { Option } from 'components/commercetools-ui/atoms/dropdown';
import { CAPACITY_SIZE, COLOR, GENERIC_ATTRIBUTES, ITEM_TAPHOLES, SHAPE } from 'helpers/constants/attributes';
import CleanFlushIcons, { isCleanFlushEnabled } from './clean-flush-icons';
const Markdown = dynamic(() => import('../../../markdown'));

type AdditionalInfoProps = {
  productspec?: any;
  description?: string;
  features?: any;
};

const AdditionalInfo: FC<AdditionalInfoProps> = ({ productspec, description, features }) => {
  const { formatMessage } = useFormat({ name: 'product' });
  const showCleanFlushIcons = isCleanFlushEnabled(productspec);
  return (
    // eslint-disable-next-line tailwindcss/no-custom-classname
    <div className="px-24 md:px-0 py-60 lg:px-0 2xl:py-120 xl:py-80">
      <div className=" flex w-full flex-col gap-40  lg:flex-row lg:gap-80 ">
        <div className="2xl:pr-180 2xl:pt-0 xl:pt-0 lg:pt-0 pt-32">
          {showCleanFlushIcons && (
            <CleanFlushIcons className="mb-24 hidden lg:flex lg:mb-32" />
          )}
          {description && (
            <div>
              <span id='product-overview' className="mb-24 block text-32 font-medium leading-10 text-primary-black lg:mb-32 xl:text-36 2xl:text-48 lg:leading-[3.25rem]">
                {formatMessage({ id: 'product.overview', defaultMessage: 'Product overview' })}
              </span>
              {/* <Markdown className="text-16 font-normal leading-6 text-[#333] lg:leading-8" markdown={description} /> */}
              <Markdown className="text-16 font-normal leading-6 text-[#333] lg:leading-8" markdown={description?.replace(/turoa/gi, (m) => m === m.toUpperCase() ? "TŪROA" : m[0] === m[0].toUpperCase() ? "Tūroa" : "tūroa")} />
              <ul className="list-disc mt-20 ml-20">
                {/* {features && features?.replaceAll('•', '- ').split('- ').map((feature: string ) => (
                  <>
                    {feature?.length > 0 && (
                      <li className="text-16 font-normal leading-6 text-[#333] lg:leading-8">{feature}</li>
                    )}
                  </>
                ))} */}

                {features &&
                  features
                    ?.replace(/turoa/gi, "Tūroa") // Replace "Turoa" with "Tūroa"
                    .replaceAll("•", "- ")
                    .split("- ")
                    .map((feature: string) => (
                      <>
                        {feature?.length > 0 && (
                          <li className="text-16 font-normal leading-6 text-[#333] lg:leading-8">
                            {feature}
                          </li>
                        )}
                      </>
                    ))}

              </ul>
            </div>
          )}
        </div>
        {/* <div className="mt-20 flex-1 px-24">
          {productspec && (
            <div className="grid w-full grid-cols-2 gap-80">
              <div className="flex flex-col items-center justify-center gap-24 lg:gap-32">
                <ArrowRightCircleIcon className="w-60 stroke-1" />
                <span className="text-12 font-normal leading-6 text-[#333] lg:text-16">
                  Capacity : {productspec?.[CAPACITY_SIZE]}L
                </span>
              </div>
              <div className="flex flex-col items-center justify-center gap-24 lg:gap-32">
                <SwatchIcon className="w-60 stroke-1" />
                <span className="text-12 font-normal leading-6 text-[#333] lg:text-16">
                  Color :{' '}
                  {productspec?.[GENERIC_ATTRIBUTES]?.find((val: { name: string }) => val?.name === COLOR)?.value}
                </span>
              </div>
              <div className="flex flex-col items-center justify-center gap-24 lg:gap-32">
                <CheckCircleIcon className="w-60 stroke-1" />
                <span className="text-12 font-normal leading-6 text-[#333] lg:text-16">
                  Shape : {productspec?.[SHAPE]}
                </span>
              </div>
              <div className="flex flex-col items-center justify-center gap-24 lg:gap-32">
                <ArchiveBoxIcon className="w-60 stroke-1" />
                <span className="text-12 font-normal leading-6 text-[#333] lg:text-16">
                  Tapholes : {productspec?.[ITEM_TAPHOLES]}
                </span>
              </div>
            </div>
          )}
        </div> */}
      </div>
      {/* <Button className="mt-48 w-full rounded-none border-2 border-[#2B2C39] bg-white px-18 py-16 shadow-sm hover:!border-[#F4F4F4] hover:!bg-[#F4F4F4] md:px-32 md:py-16 lg:w-fit">
        <span className="text-16 font-semibold leading-5 text-[#333] lg:leading-6 lg:text-[#090909]">
          {formatMessage({ id: 'add.visualiser', defaultMessage: 'Add to Bathroom Visualiser' })}
        </span>
      </Button> */}
    </div>
  );
};

export default AdditionalInfo;
